export const SHOULD_SHOW_EDIT_ADDRESS_QUERY_PARAM = "shouldShowEditAddress";
